import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StopCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stop_circle"}/>
}
